module.exports = __webpack_public_path__ + "static/fonts/iconfont.9b14de15.woff";